import { UserAddOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Drawer, Form, Input, Modal, Row, Space, Table, Typography, message } from 'antd';
import { useEffect, useState } from 'react';
import { GroupService } from '../services/Group';
import { MenuService } from '../services/Menu';
import { addUser, listUser, removeUser,  setUserGroups, setUserMenus, updateUser } from "../services/User";
const { confirm, warn } = Modal;
const User = () => {
    console.log(`[recources] render`)
    const [data, setData] = useState<any>([]);
    const [currentRecord, setCurrentRecord] = useState<any>(null);
    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState<any>(false);
    const [visible, setVisible] = useState(false);
    const [projects, setProjects] = useState([]);
    const [groups, setGroups] = useState<any>([]);
    const [menus, setMenus] = useState<any>([]);
    const layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    };


    const updateUsers = () => {
        listUser().then((v) => {
            console.log("listuser", v)
            GroupService.listAll().then((v) => {
                setGroups(v)
            })
            MenuService.listAll().then((v)=>{
                setMenus(v)
            })
            setData(v);
        }).catch((e) => {

        })
    }
    const createUser = async function () {

        form.resetFields();
        setCurrentRecord(null);
        setIsModalVisible(true)

    }
    const modify = async function (record: any) {
        setCurrentRecord(record);
        form.resetFields();
        record.password2 = record.password
        form.setFieldsValue(record)
        setIsModalVisible(true);
    }
    const mgmt = async function (record: any) {
        console.log(record)
        setCurrentRecord(record);
        form2.setFieldsValue({
            groups: record.groups.map((v:any) => v.id),
            menus: record.menus.map((v:any) => v.id)  
        })
        setVisible(true);
    }
    const sqOk = async function () {
        let v = await form2.getFieldsValue();
        console.log("form2 result", v)
        await setUserGroups(currentRecord.id, v.groups)
        await setUserMenus(currentRecord.id, v.menus)
        setVisible(false);
        updateUsers();
    }
    const remove = async function (record: any) {
        confirm(
            {
                title: "提示",
                content: "确定要删除吗？",
                okText: "确定",
                cancelText: "取消",
                onOk: () => {
                    removeUser(record.id).then(() => {
                        updateUsers();
                    });
                }
                ,
                onCancel: () => {
                    Modal.destroyAll();
                }
            });
    }


    const handleOk = () => {
        async function process() {

            await form.validateFields()
            let v = await form.getFieldsValue();
            if (v.password != v.password2)
                throw "两次密码不一致！"
            if (currentRecord) {
                v.id = currentRecord.id;
                await updateUser(v);
                message.info("用户更新成功");
            } else {
                await addUser(v);
                message.info("用户创建成功");
            }
        }
        process().then(() => {
            setIsModalVisible(false);
            updateUsers();

        }).catch((e) => {
            warn({ title: "提示", content: e });
            console.log(e)
        })
    };

    const columns = [
        {
            title: '用户名',
            dataIndex: 'username',
            key: 'username'

        },
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name'

        },

        {
            title: '菜单权限',
            dataIndex: 'menus',
            key: 'menus',
            render: (text: any, record: any) => {
                let n = record.menus.map((v: any) => {
                    return v.name;
                })
                return n.join(",")
            },

        },


        {
            title: '分组权限',
            dataIndex: 'groups',
            key: 'groups',
            render: (text: any, record: any) => {
                let n = record.groups.map((v: any) => {
                    return v.name;
                })
                return n.join(",")
            },

        },

        {
            title: '操作',
            key: 'action',
            render: (text: any, record: any) => (
                <Space size="middle">
                    <Typography.Link disabled={record.name == "admin" ? true : false} onClick={(e) => { modify(record); }}>修改</Typography.Link>
                    <Typography.Link disabled={record.name == "admin" ? true : false} onClick={(e) => { remove(record); }}>删除</Typography.Link>
                    <Typography.Link disabled={record.name == "admin" ? true : false} onClick={(e) => { mgmt(record); }}>授权</Typography.Link>
                </Space>
            ),
        },
    ];


    const onClose = () => {
        setVisible(false);
    };

    useEffect(() => {
        console.log("[resources] load resources");
        updateUsers();
    }, [])
    return <div style={{ margin: 0 }}>
        <Drawer
            title="用户授权"
            placement={"right"}
            width={500}
            onClose={onClose}
            visible={visible}
        >
            <Form
                {...layout}
                name="basic"
                onFinish={sqOk}
                form={form2}

            >
                <Form.Item
                    label="菜单权限"
                    name="menus"
                >

                    <Checkbox.Group>
                        {menus.map((v: any) => {
                            return <Checkbox value={v.id}>{v.name}</Checkbox>
                        })}
                    </Checkbox.Group>
                </Form.Item>



                <Form.Item
                    label="设备组"
                    name="groups"

                >
                    <Checkbox.Group>
                        <Row>
                            {groups.map((v: any) => {
                                return <Col span={12}>
                                    <Checkbox style={{ width: 128 }} value={v.id}>{v.name}</Checkbox>
                                </Col>
                            })}


                        </Row>
                    </Checkbox.Group>
                </Form.Item>
                <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button type="primary" htmlType="submit">
                        保存
                    </Button>
                </Form.Item>
            </Form>
        </Drawer>
        <Modal title="创建新用户" visible={isModalVisible} onOk={handleOk} onCancel={() => setIsModalVisible(false)} cancelText="取消" okText="确定">
            <Form
                {...layout}
                name="basic"
                form={form}

            >
                <Form.Item
                    label="用户名"
                    name="username"
                    rules={[
                        {
                            required: true,
                            message: '用户名不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="密码"
                    name="password"

                    rules={[
                        {
                            required: true,
                            message: '密码不能为空!',
                        },
                    ]}
                >
                    <Input value="111111" />
                </Form.Item>

                <Form.Item
                    label="确认密码"
                    name="password2"

                    rules={[
                        {
                            required: true,
                            message: '密码不能为空!',
                        },
                    ]}
                >
                    <Input value="111111" />
                </Form.Item>

                <Form.Item
                    label="姓名"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: '姓名不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>



            </Form>
        </Modal>
        <h2 className='title'>用户管理</h2>
        <Row style={{ marginBottom: 5 }}>
            <Col>
                <Button type="primary" icon={<UserAddOutlined />} onClick={() => createUser()}>新建</Button>
            </Col>
        </Row>
        <Row>
            <Col span={24}>
                <Table dataSource={data} pagination={false} columns={columns} />;
            </Col>
        </Row>
    </div>

};

export default User;